// 📄 pages/Auth/CambiarPasswordObligatorio.tsx
import React, { useState } from 'react';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import { KeyRound, RefreshCw } from 'lucide-react';
import { useAuth } from '../../context/AuthContext.tsx';
import { clearRequiereCambioPassword } from '../../services/userService.ts';

export default function CambiarPasswordObligatorio() {
  const { user } = useAuth();
  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNueva, setPasswordNueva] = useState('');
  const [passwordConfirmar, setPasswordConfirmar] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (passwordNueva.length < 6) { setError('La nueva contraseña debe tener al menos 6 caracteres.'); return; }
    if (passwordNueva !== passwordConfirmar) { setError('Las contraseñas nuevas no coinciden.'); return; }
    if (!user || !user.email) { setError('Sin sesión activa.'); return; }

    setSaving(true);
    try {
      const credential = EmailAuthProvider.credential(user.email, passwordActual);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, passwordNueva);
      await clearRequiereCambioPassword(user.uid);
    } catch (err: any) {
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password') {
        setError('La contraseña temporal actual no es correcta.');
      } else {
        setError(err.message || 'Error al cambiar la contraseña.');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center p-6">
      <form onSubmit={handleSubmit} className="bg-gray-800 p-8 rounded-xl shadow-md w-full max-w-sm space-y-4">
        <div className="flex flex-col items-center text-center gap-2 mb-2">
          <KeyRound className="w-8 h-8 text-blue-400" />
          <h1 className="text-xl font-bold">Cambia tu contraseña</h1>
          <p className="text-sm text-gray-400">
            Tu cuenta fue creada con una contraseña temporal. Debes cambiarla antes de continuar.
          </p>
        </div>

        <input
          type="password"
          placeholder="Contraseña temporal actual"
          value={passwordActual}
          onChange={(e) => setPasswordActual(e.target.value)}
          className="w-full p-2 rounded bg-gray-700 text-white"
          required
        />
        <input
          type="password"
          placeholder="Nueva contraseña"
          value={passwordNueva}
          onChange={(e) => setPasswordNueva(e.target.value)}
          className="w-full p-2 rounded bg-gray-700 text-white"
          required
          minLength={6}
        />
        <input
          type="password"
          placeholder="Confirmar nueva contraseña"
          value={passwordConfirmar}
          onChange={(e) => setPasswordConfirmar(e.target.value)}
          className="w-full p-2 rounded bg-gray-700 text-white"
          required
          minLength={6}
        />

        {error && <p className="text-red-400 text-sm">{error}</p>}

        <button
          type="submit"
          disabled={saving}
          className="w-full bg-blue-500 hover:bg-blue-600 disabled:opacity-50 py-2 rounded flex items-center justify-center gap-2"
        >
          {saving ? <RefreshCw className="w-4 h-4 animate-spin" /> : 'Cambiar contraseña'}
        </button>
      </form>
    </div>
  );
}
